<template>
    <div class="my-profile-page">
        <h4>My Profile</h4>
        <hr>

        <div class="grid-container">
            <div class="my-profile__card card card-2 shadow-sm">
                <div class="card-header">
                    <h5 class="card-title">Personal Details</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <BasicTextInput  class="col-6" label="First Name" disabled="disabled" v-model="currentUser.FirstName"/>
                        <BasicTextInput  class="col-6" label="Last Name"  disabled="disabled" v-model="currentUser.LastName" />
                    </div>
                    <BasicTextInput   class="mb-2" label="Email" disabled="disabled" v-model="currentUser.EmailAddress" />
                    <div class="row mb-2">
                        <div class="col-8">
                            <BasicTextInput label="Address" v-model="user.AddressLine1"/>
                        </div>
                        <div class="col-4">
                            <BasicTextInput label="Suite"  v-model="user.AddressLine2"/>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <BasicTextInput label="City"   v-model="user.City" />
                        </div>
                        <div class="col">
                            <StateSelect    label="State / Province"  :key="`profile-${user.StateProvinceId}`" v-model="user.StateProvinceId" :states="profileStates"/>
                        </div>
                        <div class="col">
                            <ZipCodeInput   label="Zip / Postal Code"   v-model="user.ZipCode"/>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <CountrySelect   class="col-6 mb-2"  label="Country"   :key="`profile-${user.CountryId}`" v-model="user.CountryId" @change="getStatesForProfile"/>
                        <BasicTextInput  class="col-6 mb-2" label="Cost Center" v-model="user.CostCenter" :disabled="true"/>
											</div>
                    <div class="row mb-2">
                        <PhoneNumberInput class="col-6 mb-2" label="Phone" v-model="user.MobilePhone"  />
                        <PhoneNumberInput class="col-6 mb-2" label="Fax" v-model="user.FaxNumber"  />
                    </div>
                    <div class="row mb-2" v-if="enablePersonalAddressToggle">
                        <div class="col">
                            <Checkbox label="Use This Address On Forms" v-model="user.UsePersonalAddressOnForms"/>
                        </div>
                    </div>
                </div>
            </div>


            <div class="my-profile__card card card-2 shadow-sm" v-if="can('access-sales-tax-form')">
                <div class="card-header">
                    <h5 class="card-title">Worksheet Defaults</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="container p-0 m-0">
                        <div class="row mb-2">
                            <div class="col">
                                <PercentInput placeholder="7.00%" label="Sales Tax" v-model="user.SalesTax"/>
                            </div>
                            <div class="col">
                                <Checkbox label="Round Customer Cost" v-model="user.RoundToNearestDollar"/>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                                <DefaultFreightInput placeholder="7.00%" @isDefaultFreightPercentChanged="isDefaultFreightPercentChanged" :percentInput="user.IsDefaultFreightPercent" v-model="user.DefaultFreight"/>
                            </div>
                            <div class="col">
                                <Checkbox label="Tax Freight" v-model="user.TaxFreight"/>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <PercentInput placeholder="7.00%" label="GP" v-model="user.GPPercent"/>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <PercentInput placeholder="10.00%" label="Default Deposit %" v-model="user.DefaultDeposit"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <BasicTextInput type="number" placeholder="15" label="Save Warning Interval (min)" v-model="user.OrderSaveAlertIntervalMins"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <UpdatePassword class="my-profile__card card card-2 shadow-sm"    />

            <OrderSearchTableConfig ref="orderSearchTableConfig"/>

            <div class="my-profile__card card card-2 shadow-sm" v-if="can('upload-configurators')">
                <div class="card-header">
                    <h5 class="card-title">Configurator Upload</h5>
                    <hr>
                </div>
                <div class="card-body">
										<input :key="configFileUpdateKey" :disabled="false" type="file" class="btn m-2" accept=".zip, .tsv" @change="configuratorFileSelected">
										<div class="btn-wrapper">
											<button :disabled="false" type="button" @click="uploadConfiguratorDocument" class="btn btn-primary">Upload</button>
										</div>
								</div>
						</div>

            <!-- This control is to take focus away from password inputs in UpdatePassword that mess up drag&drop in OrderSearchTableConfig if they autofocus-->
            <BasicTextInput type="text" v-show="hiderVisible"/>
        </div>
    </div>
</template>

<script>
    import { mapState }                             from 'vuex';
    import { UserService, DealerService, CountryService }           from '@/services'
    import CountrySelect                            from '../../../components/inputComponents/CountrySelect';
    import UpdatePassword                           from '@/components/UpdatePassword.vue';
    import DefaultFreightInput                      from '@/components/inputComponents/DefaultFreightInput';

    import OrderSearchTableConfig from '@/components/OrderSearchTableConfig.vue';

    export default {
        name: "MyProfile",
        components: {
          UpdatePassword,
          DefaultFreightInput,
          CountrySelect,
          OrderSearchTableConfig,
        },
        data() {
            return {
                user: {},
                profileStates: null,
                tempFiles: [],
                enablePersonalAddressToggle: false,
                hiderVisible: true,
								configFileUpdateKey: 0,
								configuratorFile: null,
            }
        },
        watch: {
            user: 'updateStates'
        },
        methods: {
						configuratorFileSelected(e){
							this.configuratorFile = event.target.files[0]
						},
						uploadConfiguratorDocument(){
							DealerService.uploadConfigurator({file: this.configuratorFile})
								.then(() => {
									this.configuratorFile = null;
									this.configFileUpdateKey++;
									this.$store.dispatch('ADD_NOTIFICATION', { text: 'Document Uploaded', type: 'success' });
								})
								.catch(err => {
									this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message  , type: 'error' });
								});
						},
            uploadAccessDBFile(){
                if (this.tempFiles.length < 1){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'No File Selected', type: 'error' });
                    return;
                }
                DealerService.uploadAccessDB(this.tempFiles[0]).then(res => {
                    this.clearFileUpload();
                    this.getCurrentUser();
                    this.$store.dispatch('ADD_NOTIFICATION', { text:'Access Database Uploaded Successfully', type: 'success' });
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response, type: 'error' });
                })
            },
            clearFileUpload(){
                this.tempFiles = [];
                this.$refs.accessDatabaseFileUpload.clear();
            },
            saveCurrentUser(){
                UserService.update(this.user).then(res => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'User Updated', type: 'success' });
                    }).catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                    })

								this.$refs.orderSearchTableConfig.saveColumns();
            },
            isDefaultFreightPercentChanged(isDefPercent){
                this.user.IsDefaultFreightPercent = isDefPercent;
            },
            getCurrentUser(){
                UserService.get().then(res => {
                    this.user = res;
                    this.getDealer();
                }).catch(err => {
                    console.error(err);
                })
                .finally(() => {
                        // this.setTotals();
                        let mimicEventDataProfile = {
                            target: {
                                value: this.user.CountryId || 1,
                                mimic: true
                            }
                        }
                        this.getStatesForProfile(mimicEventDataProfile);
                    }) 
            },
            stageFile(f){
                this.tempFiles.push(f[0]);
            },
            getStatesForProfile(e){
                CountryService.states(Number(e.target.value))
                    .then(res => {
                        this.profileStates = res;
                    })                   
            },
            updateStates(){
                const countryId = this.user.CountryId;
                CountryService.states(Number(countryId))
                    .then(res => {
                        this.profileStates = res;
                    });
            },
            getDealer(){
                let dealerId = this.adminView ? this.$route.params.id : this.currentUser.DealerId;
                DealerService.get(dealerId).then(res => {
                    this.enablePersonalAddressToggle = res.EnablePersonalAddressToggle;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message  , type: 'error' });
                })
            }
        },
        computed: {
            ...mapState(['currentUser']),
        },
        mounted(){
            this.getCurrentUser();
            this.hiderVisible = false;
        }
    }
</script>

<style scoped lang="scss">
    .my-profile-page{
        // max-width: 1800px
    }
    .grid-container {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: auto;

        .my-profile__card {
            margin: 10px;
        }
    }

    .btn-wrapper {
        width: 100%;
        padding: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .btn {
          margin: 5px;
        }
    }
</style>
